<span class="pill m-0 {{ pillType }}" [title]="toolTip" [ngClass]="{ 'pill-pill-non-std': !standard }">
  <ng-content></ng-content>
</span>
